import { AccountLink as AccountLinkComponent } from "./AccountLink";
import type { AccountLinkProps } from "./interface";
export const AccountLink = (props: AccountLinkProps) => {
  return <AccountLinkComponent {...props} />;
};
export * from "./interface";
